<template>
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.9106 3.7528L7.76293 3.29086L6.35583 0.410336C6.3174 0.331468 6.25417 0.267624 6.17607 0.228816C5.98019 0.131171 5.74216 0.212542 5.64422 0.410336L4.23712 3.29086L1.08942 3.7528C1.00264 3.76532 0.923296 3.80663 0.862549 3.86922C0.789109 3.94544 0.74864 4.04799 0.750035 4.15432C0.75143 4.26066 0.794574 4.36209 0.869987 4.43632L3.14739 6.6784L2.60934 9.84435C2.59672 9.918 2.60479 9.99374 2.63264 10.063C2.66048 10.1322 2.70698 10.1922 2.76687 10.2362C2.82676 10.2801 2.89764 10.3062 2.97147 10.3115C3.0453 10.3168 3.11913 10.3011 3.18458 10.2662L6.00003 8.77151L8.81547 10.2662C8.89234 10.3075 8.9816 10.3213 9.06714 10.3063C9.28285 10.2687 9.4279 10.0622 9.39071 9.84435L8.85266 6.6784L11.1301 4.43632C11.1921 4.37497 11.233 4.29486 11.2454 4.20723C11.2788 3.98815 11.1276 3.78535 10.9106 3.7528V3.7528Z"
      fill="currentColor"
    />
  </svg>
</template>
